import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", y = 36 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, sub, align = "left" }) {
  return (
    <div className={align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl"}>
      <Reveal>
        <p className="font-mono-adj text-xs uppercase tracking-[0.3em] text-orange-500 font-semibold" data-testid={`eyebrow-${eyebrow.slice(0, 12).replace(/\s/g, "-").toLowerCase()}`}>
          {eyebrow}
        </p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white mt-4 leading-[1.05]">
          {title}
        </h2>
      </Reveal>
      {sub && (
        <Reveal delay={0.16}>
          <p className="text-base sm:text-lg text-slate-400 leading-relaxed mt-5">{sub}</p>
        </Reveal>
      )}
    </div>
  );
}
